import { createActions } from 'redux-actions';

export default createActions(
  {
    RESET: () => ({}),
    LOAD: (robotId, mission) => ({ robotId, mission }),
    REMOVE: (robotId) => ({ robotId }),
    SET_SYNCED: (robotId, isSynced) => ({ robotId, isSynced }),
  },
  { prefix: 'MISSIONS' },
);
